import { Component, Input } from '@angular/core';
import { LocationEmployeeLog } from '../../models';

@Component({
    selector: 'location-logs',
    template: require('./location.component.pug'),
    styles: [ require('./location.component.scss')],
})
export class LocationLogsComponent {
    @Input() locationLogs: LocationEmployeeLog;

    constructor() { }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/clock-in-out/shared/ui/location/location.component.ts